import { Field as FormField, Textarea, ToggleSwitch } from '../../libs/gs-component-form';
import { Content, Header, RouterContext } from '../../libs/gs-component-right-rail';
import { Subhead } from '@xo-union/tk-ui-typography';
import { Field as FormikField } from 'formik';
import React, { useContext } from 'react';

import { Footer, Remover } from '../FormComponents';
import styles from './main.scss';
import { useWebsiteLayoutContext } from '../../context/WebsiteLayoutContext';

interface Props {
  onClose: () => void;
  setFieldValue: (field: string, value: any) => void;
  isFormDirty: boolean;
  submitForm: () => void;
  isLoading: boolean;
  header?: string;
  leftButtonText?: string;
  leftButtonOnClick?: () => void;
  noClose?: boolean;
  showVisibilityToggle?: boolean;
  modules: string[];
}

export const REGISTRY_NOTE = 'registry-note';
export const PAGE_DELETE = 'page-delete';
export const REGISTRY_NOTE_DESC =
  "Write a quick note that will appear at the top of your registry page (it's optional).";

export const EditPage: React.FC<Props> = ({
  onClose,
  isFormDirty,
  submitForm,
  setFieldValue,
  isLoading,
  header = 'Page Settings',
  leftButtonOnClick,
  leftButtonText = '',
  noClose = false,
  showVisibilityToggle = true,
  modules = [],
}) => {
  const { currentLayout } = useWebsiteLayoutContext();
  const { push } = useContext(RouterContext);

  const onHeaderClose = (): void => {
    if (isFormDirty) {
      push('confirmDiscard');

      return;
    }

    onClose();
  };

  const onDelete = (): void => push('confirmDelete');

  const isSinglePageSite = currentLayout === 'single-page';
  const pageOrSection = isSinglePageSite ? 'Section' : 'Page';

  return (
    <>
      <Header
        onClose={!noClose ? onHeaderClose : undefined}
        leftButtonOnClick={leftButtonOnClick}
        leftButtonText={leftButtonText}
        as="h1"
      >
        {header}
      </Header>
      <Content>
        <div className={styles.container}>
          <div className={styles.toggle}>
            {showVisibilityToggle && (
              <>
                <Subhead>{`${pageOrSection} details`}</Subhead>
                <FormikField
                  name="show"
                  value="Visible"
                  component={ToggleSwitch}
                  enabledText="Visible"
                  disabledText="Hidden"
                  setFieldValue={setFieldValue}
                />
              </>
            )}
          </div>
          <FormikField component={FormField} name="title" label={`${pageOrSection} Name`} data-testid="title" />
          {modules.includes(REGISTRY_NOTE) && (
            <div className={styles.noteContainer}>
              <div>Registry Note To The Guest</div>
              <div className={styles.description}>{REGISTRY_NOTE_DESC}</div>
              <FormikField component={Textarea} name="note" label="Message" data-testid="note" rows="6" />
            </div>
          )}
          {modules.includes(PAGE_DELETE) && <Remover onClick={onDelete}>Delete page</Remover>}
        </div>
      </Content>
      <Footer primaryOnClick={submitForm} secondaryOnClick={onClose} showSpinner={isLoading} />
    </>
  );
};
